import dayjs from "dayjs";

const isMoreThan30Days = (date1, date2 = dayjs()) => {
  const diffInDays = dayjs(date2).diff(dayjs(date1), "day");
  return diffInDays > 30;
};

export default isMoreThan30Days;
